const fomratter = new Intl.NumberFormat("en-US");
const Formatter = (amount) => fomratter.format(amount);

export default Formatter;
